import { graphql } from "gql";

const USER_QUERY = graphql(`
  query User($id: [ID!]!) {
    user(id: $id) {
      ...User
    }
  }
`);

export default USER_QUERY;
